import React, { useState, useEffect } from 'react';
import PageWrapper from '../../componenti/PageWrapper';
import PageContent from '../../componenti/PageContent';
import { Box, Typography, Button, Tabs, Tab, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useAuth, API_BASE_URL } from '../../context/AuthContext';

import HomeAdmin from './HomeAdmin';
import EventsAdmin from './EventsAdmin';
import SchedulesAdmin from './SchedulesAdmin';
import GalleryAdmin from './GalleryAdmin';
import ThemeAdmin from './ThemeAdmin';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function Dashboard() {
  const { user, logout } = useAuth();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <PageWrapper>
      <PageContent title="Pannello di Controllo">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h6">
            Ciao, {user?.email}
          </Typography>
          <Button variant="outlined" color="error" onClick={logout}>Esci</Button>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
            <Tab label="Home Page" />
            <Tab label="Orari Corsi" />
            <Tab label="News" />
            <Tab label="Eventi Passati" />
            <Tab label="Galleria" />
            <Tab label="Colori del sito" />
          </Tabs>
        </Box>

        <TabPanel value={tabIndex} index={0}>
          <HomeAdmin />
        </TabPanel>

        <TabPanel value={tabIndex} index={1}>
          <SchedulesAdmin />
        </TabPanel>

        <TabPanel value={tabIndex} index={2}>
          <EventsAdmin isPastView={false} />
        </TabPanel>

        <TabPanel value={tabIndex} index={3}>
          <EventsAdmin isPastView={true} />
        </TabPanel>

        <TabPanel value={tabIndex} index={4}>
          <GalleryAdmin />
        </TabPanel>

        <TabPanel value={tabIndex} index={5}>
          <ThemeAdmin />
        </TabPanel>

      </PageContent>
    </PageWrapper>
  );
}
